import type { AiCreditPackOption, UsageResourceTileConfig } from "./types";

// Prices are intentionally hardcoded for now, matching the current Stripe price list.
export const AI_CREDIT_PACK_OPTIONS: AiCreditPackOption[] = [
  {
    id: "monthly-100",
    credits: 100,
    priceUsd: 125,
    billingInterval: "monthly",
  },
  {
    id: "monthly-250",
    credits: 250,
    priceUsd: 313,
    billingInterval: "monthly",
  },
  {
    id: "monthly-500",
    credits: 500,
    priceUsd: 625,
    billingInterval: "monthly",
  },
  {
    id: "monthly-1000",
    credits: 1000,
    priceUsd: 1250,
    billingInterval: "monthly",
  },
  {
    id: "monthly-2500",
    credits: 2500,
    priceUsd: 3125,
    billingInterval: "monthly",
  },
  {
    id: "monthly-3500",
    credits: 3500,
    priceUsd: 4375,
    billingInterval: "monthly",
  },
  {
    id: "monthly-5000",
    credits: 5000,
    priceUsd: 6250,
    billingInterval: "monthly",
  },
  {
    id: "monthly-7500",
    credits: 7500,
    priceUsd: 9375,
    billingInterval: "monthly",
  },
  {
    id: "annual-100",
    credits: 100,
    priceUsd: 1200,
    billingInterval: "annual",
  },
  {
    id: "annual-250",
    credits: 250,
    priceUsd: 3000,
    billingInterval: "annual",
  },
  {
    id: "annual-500",
    credits: 500,
    priceUsd: 6000,
    billingInterval: "annual",
  },
  {
    id: "annual-1000",
    credits: 1000,
    priceUsd: 12000,
    billingInterval: "annual",
  },
  {
    id: "annual-2500",
    credits: 2500,
    priceUsd: 30000,
    billingInterval: "annual",
  },
  {
    id: "annual-3500",
    credits: 3500,
    priceUsd: 42000,
    billingInterval: "annual",
  },
  {
    id: "annual-5000",
    credits: 5000,
    priceUsd: 60000,
    billingInterval: "annual",
  },
  {
    id: "annual-7500",
    credits: 7500,
    priceUsd: 90000,
    billingInterval: "annual",
  },
];

export const USAGE_RESOURCE_TILES: UsageResourceTileConfig[] = [
  {
    key: "ai_builders",
    title: "Assigned AI Builders",
    subtitle: "Builder licenses assigned",
    accentClassName:
      "border-[#0099ff] bg-white shadow-[0_0_0_4px_rgba(0,153,255,0.12),0_0_0_1px_#0099ff]",
    progressClassName: "bg-sky-500",
  },
  {
    key: "agents",
    title: "Agents",
    subtitle: "Active agents",
    accentClassName:
      "border-[#0099ff] bg-white shadow-[0_0_0_4px_rgba(0,153,255,0.12),0_0_0_1px_#0099ff]",
    progressClassName: "bg-sky-500",
  },
  {
    key: "deployed_apps",
    title: "Deployed Apps",
    subtitle: "Apps currently deployed",
    accentClassName:
      "border-[#0099ff] bg-white shadow-[0_0_0_4px_rgba(0,153,255,0.12),0_0_0_1px_#0099ff]",
    progressClassName: "bg-sky-500",
  },
  {
    key: "shared_ai_credits",
    title: "Shared GAUs",
    subtitle: "GAUs used from shared pool",
    accentClassName:
      "border-[#0099ff] bg-white shadow-[0_0_0_4px_rgba(0,153,255,0.12),0_0_0_1px_#0099ff]",
    progressClassName: "bg-sky-500",
    mocked: true,
  },
];
